import {Injectable} from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {StorageUtils} from '../../../utils';

@Injectable()
export class AgreementServices {
    public apiUrl = `${environment.apiUrl}/api/v1`;
    andebug = false;

    constructor(private http: Http) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;
    };

    /**
     * agreement
     * agreement contents 조회
     * Mothod : Get
     * API No : 3.00
     * /api/v1/{cmpnNo}/agreement/${langCd}/${target}
     * **/
    getAgreementContents(target, langCd) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/agreement/${langCd}/${target}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * agreement
     * agreement contents 추가
     * Mothod : Post
     * API No : 1.00
     * /api/v1/{cmpnNo}/agreement
     * 미사용. 이력 관리 기능 개발 시, 사용 예정
     * **/
    addAgreementContents(newAgreementContents) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/agreement`;

        return this.http
        .post(url, newAgreementContents)
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * agreement
     * agreement contents 삭제
     * Mothod : Delete
     * API No : 1.00
     * /api/v1/{cmpnNo}/agreement/${agreementNo}
     * 미사용. 이력 관리 기능 개발 시, 사용 예정
     * **/
    deleteAgreementContents(agreementNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/agreement/${agreementNo}`;

        return this.http
        .delete(url)
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/agreement.services.ts